"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ui = require("@unite-us/ui");
var _ShowHide = _interopRequireDefault(require("../../ShowHide"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var NameField = function NameField(props) {
  var id = props.id,
    className = props.className,
    firstNamePath = props.firstNamePath,
    lastNamePath = props.lastNamePath,
    middleNameInitPath = props.middleNameInitPath,
    nicknamesPath = props.nicknamesPath,
    titlePath = props.titlePath,
    titleOptions = props.titleOptions,
    titleLabelKey = props.titleLabelKey,
    titleValueKey = props.titleValueKey,
    suffixOptions = props.suffixOptions,
    suffixLabelKey = props.suffixLabelKey,
    suffixValueKey = props.suffixValueKey,
    suffixPath = props.suffixPath,
    hideTitle = props.hideTitle,
    hideFirstName = props.hideFirstName,
    hideLastName = props.hideLastName,
    hideMiddleName = props.hideMiddleName,
    hideSuffix = props.hideSuffix,
    hideNicknames = props.hideNicknames;
  var nameFieldClass = function nameFieldClass() {
    return (0, _classnames["default"])({
      'ui-name-field': true
    }, className);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: nameFieldClass()
  }, /*#__PURE__*/_react["default"].createElement(_ShowHide["default"], {
    hide: hideTitle
  }, /*#__PURE__*/_react["default"].createElement(_ui.SelectField, _extends({
    id: "title",
    name: "title",
    label: "Title",
    options: titleOptions,
    labelKey: titleLabelKey,
    valueKey: titleValueKey
  }, _lodash["default"].get(props, titlePath, {})))), /*#__PURE__*/_react["default"].createElement(_ShowHide["default"], {
    hide: hideFirstName
  }, /*#__PURE__*/_react["default"].createElement(_ui.InputField, _extends({
    id: "first-name",
    name: "first_name",
    label: "First Name"
  }, _lodash["default"].get(props, firstNamePath, {})))), /*#__PURE__*/_react["default"].createElement(_ShowHide["default"], {
    hide: hideLastName
  }, /*#__PURE__*/_react["default"].createElement(_ui.InputField, _extends({
    id: "last-name",
    name: "last_name",
    label: "Last Name"
  }, _lodash["default"].get(props, lastNamePath, {})))), /*#__PURE__*/_react["default"].createElement(_ShowHide["default"], {
    hide: hideMiddleName
  }, /*#__PURE__*/_react["default"].createElement(_ui.InputField, _extends({
    id: "middle-name-initial",
    name: "middle-name-initial",
    label: "Middle Initial"
  }, _lodash["default"].get(props, middleNameInitPath, {})))), /*#__PURE__*/_react["default"].createElement(_ShowHide["default"], {
    hide: hideSuffix
  }, /*#__PURE__*/_react["default"].createElement(_ui.SelectField, _extends({
    id: "suffix",
    name: "suffix",
    label: "Suffix",
    options: suffixOptions,
    labelKey: suffixLabelKey,
    valueKey: suffixValueKey
  }, _lodash["default"].get(props, suffixPath, {})))), /*#__PURE__*/_react["default"].createElement(_ShowHide["default"], {
    hide: hideNicknames
  }, /*#__PURE__*/_react["default"].createElement(_ui.InputField, _extends({
    id: "nicknames",
    name: "nick-names",
    label: "Nicknames"
  }, _lodash["default"].get(props, nicknamesPath, {})))));
};
NameField.propTypes = {
  /** id for reference */
  id: _propTypes["default"].string.isRequired,
  /** className for reference */
  className: _propTypes["default"].string,
  /** Path to first name field */
  firstNamePath: _propTypes["default"].string,
  /** Path to last name field */
  lastNamePath: _propTypes["default"].string,
  /** Path to middle name field */
  middleNameInitPath: _propTypes["default"].string,
  /** Path to nick name field */
  nicknamesPath: _propTypes["default"].string,
  /** Path to suffix field */
  suffixPath: _propTypes["default"].string,
  /** Path tot title field */
  titlePath: _propTypes["default"].string,
  /** select Value for suffix key */
  suffixLabelKey: _propTypes["default"].string,
  /** Select options for suffix */
  suffixOptions: _propTypes["default"].array,
  /** Select for suffix value */
  suffixValueKey: _propTypes["default"].string,
  /** Select Value for title key */
  titleLabelKey: _propTypes["default"].string,
  /** Select options for title */
  titleOptions: _propTypes["default"].array,
  /** Select Value for title */
  titleValueKey: _propTypes["default"].string,
  /** If true hides title */
  hideTitle: _propTypes["default"].bool,
  /** If true hides first name */
  hideFirstName: _propTypes["default"].bool,
  /** If true hides last name */
  hideLastName: _propTypes["default"].bool,
  /** If true hides middle name */
  hideMiddleName: _propTypes["default"].bool,
  /** If true hides suffix */
  hideSuffix: _propTypes["default"].bool,
  /** If true hides nicknames */
  hideNicknames: _propTypes["default"].bool
};
NameField.defaultProps = {
  className: '',
  firstNamePath: 'first_name',
  lastNamePath: 'last_name',
  middleNameInitPath: 'middle_name_initial',
  nicknamesPath: 'nicknames',
  suffixLabelKey: 'display_name',
  suffixOptions: [],
  suffixPath: 'suffix',
  suffixValueKey: undefined,
  titleLabelKey: 'display_name',
  titleOptions: [],
  titlePath: '',
  titleValueKey: undefined,
  hideTitle: false,
  hideFirstName: false,
  hideLastName: false,
  hideMiddleName: false,
  hideSuffix: false,
  hideNicknames: false
};
var _default = exports["default"] = NameField;